export enum recruiterRecruitmentsDetailTypes {
  FETCH_RECRUITER_RECRUIMENTS_DETAIL_REQUEST = "FETCH_RECRUITER_RECRUIMENTS_DETAIL_REQUEST",
  FETCH_RECRUITER_RECRUIMENTS_DETAIL_SUCCESS = "FETCH_RECRUITER_RECRUIMENTS_DETAIL_SUCCESS",
  FETCH_RECRUITER_RECRUIMENTS_DETAIL_FAILURE = "FETCH_RECRUITER_RECRUIMENTS_DETAIL_FAILURE",
}